module.exports = __webpack_public_path__ + "img/icon-stockpicker-training-done@3x.3bbe0405.png";